import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { deleteFeaturesByCondition } from "../../../resources/deleteFeature";
import { useNotification } from "../../../hooks/notifications/useNotification";
import { useTempTableCondition } from "../../../hooks/table/useTempTableCondition";
import { useSGisLayer } from "../../../hooks/sgis/useSGisLayers";
import { useSGisLayerRedraw } from "../../../hooks/sgis/useSGisLayerRedraw";

import { LayerInfo } from "../../../interfaces/resourceInfo";

export const useDeleteFeatures = (layer: LayerInfo) => {
  const { t } = useTranslation("table");
  const [deleteFeatures, { data: deleteResult, error: deleteError }] = deleteFeaturesByCondition.use();
  const resultCondition = useTempTableCondition(layer);
  const sgisLayer = useSGisLayer(layer.name);
  const redrawLayer = useSGisLayerRedraw(sgisLayer);

  useNotification(deleteResult && !deleteError, {
    success: true,
    title: t("deleteSuccess"),
  });

  useNotification(deleteError, {
    error: true,
    title: t("deleteError"),
  });

  return useCallback(async () => {
    if (!layer.name) {
      return;
    }

    await deleteFeatures({ input: { name: layer.name, condition: resultCondition, tableName: layer.tableName } });

    redrawLayer();
  }, [deleteFeatures, layer.name, layer.tableName, resultCondition, sgisLayer]);
};
